var map = {
	"./GTA.png": 1297,
	"./GUILD.png": 189,
	"./background.png": 402,
	"./bsc.png": 322,
	"./copper.png": 1298,
	"./discord.png": 404,
	"./eth.png": 323,
	"./gitBook.png": 406,
	"./guild_logo.png": 403,
	"./info.png": 408,
	"./kyoko.png": 1299,
	"./logo.png": 1300,
	"./telegram.png": 407,
	"./twitter.png": 405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1296;